module.exports = __webpack_public_path__ + "static/grid-302f16bf3277b160cbd3f80513c76171.mp4";